import React from 'react'
import PropTypes from 'prop-types'
import { compose, withHandlers } from 'recompose'
import { watchKey } from '../../../lib/utils/dom'
import KEY from '../../../lib/constants/key'

const enhance = compose(
  withHandlers({
    onKeyDown: ({ applyResultsHandler }) => e => {
      watchKey(e, KEY.RETURN, applyResultsHandler)
    }
  })
)

const SearchBarFooterActions = ({ cancelHandler, clearHandler, applyResultsHandler, onKeyDown, countResults }) => (
  <div className='SearchBarFooterActions'>
    <div className='SearchBarFooterActions-action SearchBarFooterActions-action--clear'>
      <button type='button'
        className='Button Button--link Button--linkSecondary'
        onClick={e => {
          e.stopPropagation()
          if (clearHandler) {
            clearHandler(e)
          } else {
            cancelHandler(e)
          }
        }}
      >
        Clear
      </button>
    </div>
    <div className='SearchBarFooterActions-action SearchBarFooterActions-action--submit'>
      <button type='button'
        className='Button Button--primary'
        onClick={applyResultsHandler}
        onKeyDown={onKeyDown}
      >
        Show Homes {countResults !== null && countResults !== undefined && `(${countResults})`}
      </button>
    </div>
  </div>
)

SearchBarFooterActions.propTypes = {
  cancelHandler: PropTypes.func.isRequired,
  clearHandler: PropTypes.func,
  applyResultsHandler: PropTypes.func.isRequired,
  onKeyDown: PropTypes.func.isRequired,
  countResults: PropTypes.oneOfType([PropTypes.number, PropTypes.bool])
}

export default enhance(SearchBarFooterActions)
